import React from "react";
import {Button, Fade, ListItemIcon, Menu, MenuItem} from "@mui/material";
import useAuth from "../../../hooks/useAuth";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {RouteAdmin} from "../../../routes/RouteAdmin";

export default function MenuAccount() {

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const {logout} = useAuth();
    const {auth} = useAuth();
    const idUser = auth ? auth?.primaryUser?.idUser : null;
    const name = auth ? auth?.primaryUser?.name : null;
    const surnames = auth ? auth?.primaryUser?.surnames : null;
    const role = auth ? auth.primaryUser.role : null
    const navigate = useNavigate();
    const {t} = useTranslation()
    

    const myAccount = () => {
        navigate(`${RouteAdmin.USER_EDIT.path}/${idUser}`);
    }
    // Dropdown state for custom menu
    const [dropdownOpen, setDropdownOpen] = React.useState(false);
    const dropdownRef = React.useRef(null);

    // Close dropdown on outside click
    React.useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        }
        if (dropdownOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownOpen]);

    return (
        <div className="menu-account" ref={dropdownRef} style={{ position: "relative", display: "inline-block" }}>
            <div
                style={{ background: "#fff", padding: "6px 12px", borderRadius: 10, boxShadow: "0 1px 4px rgba(0,0,0,0.08)", fontWeight: "500", cursor: "pointer", userSelect: "none", display: "flex", alignItems: "center", gap: 6 }}
                onClick={() => setDropdownOpen((open) => !open)}
                aria-haspopup="true"
                aria-expanded={dropdownOpen}
            >
                Hola, <strong style={{ color: "black" }}>{name ? name : ""} {surnames ? surnames : ""}</strong>
            </div>
            {dropdownOpen && (
                <div
                    style={{
                        position: "absolute",
                        right: 0,
                        top: "calc(100% + 4px)",
                        minWidth: 160,
                        background: "rgba(255,255,255,0.97)",
                        boxShadow: "0px 8px 30px rgba(0,0,0,0.15)",
                        borderRadius: 10,
                        border: "1px solid rgba(255,255,255,0.3)",
                        zIndex: 9999,
                        padding: "8px 0"
                    }}
                >
                    <div
                        style={{
                            padding: "8px 20px",
                            cursor: "pointer",
                            fontWeight: 500,
                            borderRadius: 8,
                            transition: "background 0.15s, color 0.15s"
                        }}
                        onClick={() => { setDropdownOpen(false); logout(); }}
                        onMouseDown={e => e.preventDefault()}
                        tabIndex={0}
                        onKeyDown={e => { if (e.key === "Enter" || e.key === " ") { setDropdownOpen(false); logout(); } }}
                    >
                        {t('logout') || 'Cerrar sesión'}
                    </div>
                </div>
            )}
        </div>
    );
}
